import { useSurface } from './useSurface';
import { Box } from '@withjoy/joykit';
import type { LayerData } from '../../components/Layer.types';
import React, { useEffect, useState } from 'react';
import { layerLayoutToCss } from '@apps/card/utils';

export const Hover = ({ layers }: { layers: readonly LayerData[] }) => {
  const [{ scale, hoverLayerIndex }] = useSurface();

  const [isDragging, setIsDragging] = useState(false);
  useEffect(() => {
    const onPointerDown = () => setIsDragging(true);
    const onPointerUp = () => setIsDragging(false);
    addEventListener('pointerdown', onPointerDown, true);
    addEventListener('pointerup', onPointerUp, true);
    return () => {
      removeEventListener('pointerdown', onPointerDown, true);
      removeEventListener('pointerup', onPointerUp, true);
    };
  }, [setIsDragging]);

  if (isDragging) return null;

  if (hoverLayerIndex === undefined) return null;
  const layer = layers[hoverLayerIndex];

  const { layout } = layer;

  return (
    <Box
      position="absolute"
      pointerEvents="none"
      border="1px solid hsl(100, 50%, 20%, 0.4)"
      style={layerLayoutToCss(layout, scale)}
    ></Box>
  );
};
